/* Copyright (c) 2020-present CloudIO Inc */

import { page as SamplePage } from '../../help/sample_pages/SamplePageSimple';
import { Platform } from '../../platform/Platform';
import { ComponentManagerFn } from '../../registry/Component.type';
import { baseComponentManager } from '../../registry/Components';
import { defaultValue } from './Markdown';

const MarkdownManager: ComponentManagerFn<'Markdown'> = (
  platform: Platform,
) => {
  return {
    ...baseComponentManager<'Markdown'>(platform, 'Markdown'),
    type: 'Markdown',
    name: 'Markdown',
    defaultValue,
    props: {
      markdown: {
        label: 'Markdown',
        type: 'string',
        multiline: true,
      },
    },
    category: 'Dashboard',
    icon: { iconName: 'markdown', iconType: 'brands' },
    description: 'Use this component to display markdown formated content.',
    helpRenders: [
      {
        title: 'Markdown',
        description: 'Sample Markdown',
        page: SamplePage,
        exampleId: 'e1',
        clearParentChildren: true,
        height: 420,
        visibleProps: ['markdown'],
        item: {
          itemId: 'a1',
          props: {
            markdown: `
##### Header 5
- One
- Two
- Three

\`\`\`json
{"a": "value"}
\`\`\`

> Quote

[A link](https://google.com)
`,
          },
          children: [],
          type: 'Markdown',
          parent: 'columnPanel1',
        },
      },
    ],
  };
};

export default MarkdownManager;
